<template>
  <div class="foot">

    <el-card :body-style="{ padding: '0px' ,borderRadius:'20px'}" style="background-color: #034172" shadow="never">

      <el-container>
        <el-main style="padding-bottom: 0;margin-bottom: -40px">

          <el-row :gutter="20">
            <el-col :span="4">
              <div class="image-style">
                <el-image style="height: 44px;width: 44px"
                          fit="cover" :src="require('@/assets/images/home/logo_white.png')"></el-image>
              </div>
            </el-col>

            <el-col :span="1">
              <div class="div-divide"></div>
            </el-col>

            <el-col :span="14">

              <div >
                <el-link class="link-style" :underline="false" type="info" @click="goHome">首页</el-link>
<!--                <el-link class="link-style" :underline="false" type="info" @click="goZenTao">禅道</el-link>-->
<!--                <el-link class="link-style" :underline="false" type="info" @click="goGitLab">GitLab</el-link>-->
<!--                <el-link class="link-style" :underline="false" type="info" @click="goYApi">YApi</el-link>-->

              </div>
            </el-col>

            <el-col :span="1">
              <div class="div-divide"></div>
            </el-col>

            <el-col :span="4">
              <div>
                <el-image style="width: 100px;" :src="require('@/assets/images/home/logo_white.png')"></el-image>
              </div>
              <div style="font-size: 14px;color: #909399">
                小D的Studio
              </div>
            </el-col>
          </el-row>

        </el-main>
        <el-footer height="90px">
          <div style="color: #909399;text-align: center;font-size: 14px">
            <div style="margin-bottom: 5px">
              本站所有免费资源均由网友提供，本站仅为网友提供信息的交流平台，所有资源版权归原权利人,请勿将下载的免费资源用于商业用途，因此造成的任何责任与本站无关!
            </div>
            <div style="margin-bottom: 10px">
              如有侵权，请联系本站删除!------>跳转至
              <el-link type="info" @click="goFeedback" style="margin-bottom: 3px">问题反馈</el-link>
            </div>
            <div>

              <el-link type="info" @click="openICPBeianWeb" style="margin-bottom: 8px;margin-right: 50px">
                备案号：辽ICP备19008696号-1
              </el-link>

              <el-image style="width: 20px;height: 20px;margin-left: 50px" :src="require('@/assets/images/home/备案图标.png')"></el-image>
              <el-link type="info" @click="openGngAnBeianWeb" style="margin-bottom: 8px">
                辽公网安备 21010402000395号
              </el-link>

            </div>
          </div>

        </el-footer>
      </el-container>

    </el-card>

  </div>
</template>

<script>
import Common from '../../../../js/Common'

export default {
  name: 'Footer',
  methods: {
    goHome () {
      if (this.$route.path === '/') {
        return
      }
      this.$router.push('/')
    },
    goZenTao () {
      window.open(Common.url_ZenTao)
    },
    goGitLab () {
      window.open(Common.url_GitLab)
    },
    goYApi () {
      window.open(Common.url_YApi)
    },
    openICPBeianWeb () {
      window.open('https://beian.miit.gov.cn/')
    },
    openGngAnBeianWeb () {
      window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=21010402000395')
    },
    goFeedback () {
      if (this.$route.path === '/about/feedback') {
        return
      }
      this.$router.push('/about/feedback')
    }

  }
}
</script>

<style scoped>
.foot{
  width: 100%;
  height: 196px;
  min-width: 1180px;
  max-width: 1920px;
  text-align: center;
  margin-top: 30px;
}

.div-divide{
  width: 1px;
  height: 60px;
  margin: 0 8px;
  vertical-align: middle;
  background-color: #909399;
  display: inline-block;
  position: relative;

}

.link-style{
  margin: 20px 20px;
}

.image-style{
  margin: 15px 0;
}

</style>



// WEBPACK FOOTER //
// src/components/pc/pages/navi/Footer.vue